import { StepContainer } from './StepContainer'
import { StepControls } from './StepControls'
import { StepSection } from './StepSection'

export const Step = Object.assign(StepContainer, {
  Controls: StepControls,
  Section: StepSection
})
